module.exports = __webpack_public_path__ + "img/sanciones.7ad8e496.jpg";